import { useVideoTrack, useLocalSessionId } from "@daily-co/daily-react";
import cn from "../../../../../../../../core/utils/cn_utils";
import { useEffect, useRef } from "react";
import { User, Loader2, Mic, MicOff } from "lucide-react";

export default function Video({ id, classNames, audioState }) {
    const videoState = useVideoTrack(id);
    const videoRef = useRef(null);
    const localSessionId = useLocalSessionId();

    useEffect(() => {
        if (videoRef.current && videoState?.track) {
            const stream = new MediaStream([videoState.track]);
            videoRef.current.srcObject = stream;
        }
    }, [videoState?.track]);

    const isLocal = id === localSessionId;
    const isVideoPlayable = videoState?.state === 'playable';
    const isVideoLoading = videoState?.state === 'loading';
    const isAudioEnabled = audioState === true;

    return (
        <div className={cn(
            "relative w-full h-full bg-slate-900 rounded-lg overflow-hidden",
            classNames
        )}>
            {isVideoPlayable ? (
                <video
                    ref={videoRef}
                    autoPlay
                    playsInline
                    muted={true} // Always mute video element since we're using DailyAudio
                    className="w-full h-full object-cover"
                />
            ) : (
                <div className="absolute inset-0 flex items-center justify-center bg-slate-900/50 backdrop-blur-sm">
                    <div className="flex flex-col items-center">
                        <div className="w-16 h-16 rounded-full bg-slate-800/70 flex items-center justify-center mb-2 backdrop-blur-sm">
                            <User className="w-8 h-8 text-pink-300" />
                        </div>
                        <p className="text-sm text-pink-300">Camera Off</p>
                    </div>
                </div>
            )}
            
            {/* Video loading indicator */}
            {isVideoLoading && (
                <div className="absolute inset-0 flex items-center justify-center bg-slate-900/50 backdrop-blur-sm">
                    <Loader2 className="w-8 h-8 text-pink-300 animate-spin" />
                </div>
            )}

            {/* Audio status indicator - only show for local participant */}
            {isLocal && (
                <div className={cn(
                    "absolute bottom-2 right-2 p-1.5 rounded-full transition-all duration-300",
                    !isAudioEnabled ? "bg-red-600/80" : "bg-green-600/80"
                )}>
                    {!isAudioEnabled ? (
                        <MicOff className="w-4 h-4 text-white" />
                    ) : (
                        <Mic className="w-4 h-4 text-white" />
                    )}
                </div>
            )}
        </div>
    );
}